<script>
import * as restfulService from '../../../../../services/restfulService'
import * as MESSAGES from '../../../../../messages'

import bus from '@utils/bus'
import helpers from '@mixins/helper'
import {mapActions, mapGetters} from 'vuex'

import moment from 'moment'
import {cloneDeep} from 'lodash'
import {email, required, requiredIf} from 'vuelidate/lib/validators'

export default {
  mixins: [helpers],
  props: ['dados'],
  data () {
    return {
      buscandoCidades: false,
      buscarCidade: null,
      buscarNaturalidade: null,
      botaoClicado: false,
      mostrarDatepickerDtNascimento: false,
      data: {
        pessoa: {
          nome: '',
          email: '',
          email_alternativo: '',
          cep: '',
          rua: '',
          numero: '',
          bairro: '',
          complemento: '',
          ref_cidade: ''
        },
        pessoa_fisica: {
          dt_nascimento: '',
          dt_nascimento_formatada: '',
          fone_residencial: '',
          fone_celular: '',
          fone_profissional: '',
          fone_recado: '',
          tipo_sanguineo: '',
          ref_estado_civil: '',
          ref_raca: '',
          ref_naturalidade: '',
          ref_nacionalidade: '',
          nome_mae: '',
          cpf: '',
          rg_numero: '',
          sexo: ''
        }
      },
      dependencias: {
        tipos_sanguineos: [
          {text: 'O+'},
          {text: 'O-'},
          {text: 'A+'},
          {text: 'A-'},
          {text: 'B+'},
          {text: 'B-'},
          {text: 'AB+'},
          {text: 'AB-'}
        ],
        cidades: [],
        cidades_naturalidade: [],
        estados_civis: [],
        racas: [],
        paises: [],
        tipos_sexo: [
          {value: 'M', text: 'Masculino'},
          {value: 'F', text: 'Feminino'}
        ]
      }
    }
  },
  validations: {
    data: {
      pessoa: {
        nome: {required},
        email: {required, email},
        email_alternativo: {email},
        cep: {required},
        rua: {required},
        numero: {required},
        bairro: {required},
        ref_cidade: {required}
      },
      pessoa_fisica: {
        dt_nascimento: {required},
        dt_nascimento_formatada: {required},
        fone_residencial: {
          required: requiredIf(function () {
            return !this.data.pessoa_fisica.fone_celular && !this.data.pessoa_fisica.fone_profissional && !this.data.pessoa_fisica.fone_recado
          })
        },
        fone_celular: {
          required: requiredIf(function () {
            return !this.data.pessoa_fisica.fone_residencial && !this.data.pessoa_fisica.fone_profissional && !this.data.pessoa_fisica.fone_recado
          })
        },
        fone_profissional: {
          required: requiredIf(function () {
            return !this.data.pessoa_fisica.fone_residencial && !this.data.pessoa_fisica.fone_celular && !this.data.pessoa_fisica.fone_recado
          })
        },
        fone_recado: {
          required: requiredIf(function () {
            return !this.data.pessoa_fisica.fone_residencial && !this.data.pessoa_fisica.fone_celular && !this.data.pessoa_fisica.fone_profissional
          })
        },
        ref_estado_civil: {required},
        ref_raca: {required},
        ref_naturalidade: {required},
        ref_nacionalidade: {required},
        nome_mae: {required},
        cpf: {required},
        rg_numero: {required},
        sexo: {required}
      }
    }
  },
  computed: {
    ...mapGetters(['currentUser']),
    menorDeIdade: function () {
      return moment().diff(moment(this.data.pessoa_fisica.dt_nascimento, 'YYYY-MM-DD'), 'years', false) < 18
    },
    pessoaNomeErros () {
      const erros = []
      if (!this.$v.data.pessoa.nome.$dirty) return erros
      !this.$v.data.pessoa.nome.required && erros.push(MESSAGES.VALIDATION_REQUIRED)
      return erros
    },
    pessoaEmailErros () {
      const erros = []
      if (!this.$v.data.pessoa.email.$dirty) return erros
      !this.$v.data.pessoa.email.email && erros.push(MESSAGES.VALIDATION_EMAIL)
      !this.$v.data.pessoa.email.required && erros.push(MESSAGES.VALIDATION_REQUIRED)
      return erros
    },
    pessoaEmailAlternativoErros () {
      const erros = []
      if (!this.$v.data.pessoa.email_alternativo.$dirty) return erros
      !this.$v.data.pessoa.email_alternativo.email && erros.push(MESSAGES.VALIDATION_EMAIL)
      return erros
    },
    pessoaCepErros () {
      const erros = []
      if (!this.$v.data.pessoa.cep.$dirty) return erros
      !this.$v.data.pessoa.cep.required && erros.push(MESSAGES.VALIDATION_REQUIRED)
      return erros
    },
    pessoaRuaErros () {
      const erros = []
      if (!this.$v.data.pessoa.rua.$dirty) return erros
      !this.$v.data.pessoa.rua.required && erros.push(MESSAGES.VALIDATION_REQUIRED)
      return erros
    },
    pessoaNumeroErros () {
      const erros = []
      if (!this.$v.data.pessoa.numero.$dirty) return erros
      !this.$v.data.pessoa.numero.required && erros.push(MESSAGES.VALIDATION_REQUIRED)
      return erros
    },
    pessoaBairroErros () {
      const erros = []
      if (!this.$v.data.pessoa.bairro.$dirty) return erros
      !this.$v.data.pessoa.bairro.required && erros.push(MESSAGES.VALIDATION_REQUIRED)
      return erros
    },
    pessoaRefCidadeErros () {
      const erros = []
      if (!this.$v.data.pessoa.ref_cidade.$dirty) return erros
      !this.$v.data.pessoa.ref_cidade.required && erros.push(MESSAGES.VALIDATION_REQUIRED)
      return erros
    },
    pessoaFisicaDtNascimentoErros () {
      const erros = []
      if (!this.$v.data.pessoa_fisica.dt_nascimento.$dirty) return erros
      if (!this.$v.data.pessoa_fisica.dt_nascimento_formatada.$dirty) return erros
      !this.$v.data.pessoa_fisica.dt_nascimento.required && erros.push(MESSAGES.VALIDATION_REQUIRED)
      !this.$v.data.pessoa_fisica.dt_nascimento_formatada.required && erros.push(MESSAGES.VALIDATION_REQUIRED)
      console.log(erros)
      return erros
    },
    pessoaFisicaFoneResidencialErros () {
      const erros = []
      if (!this.$v.data.pessoa_fisica.fone_residencial.$dirty) return erros
      !this.$v.data.pessoa_fisica.fone_residencial.required && erros.push(MESSAGES.VALIDATION_REQUIRED)
      return erros
    },
    pessoaFisicaFoneCelularErros () {
      const erros = []
      if (!this.$v.data.pessoa_fisica.fone_celular.$dirty) return erros
      !this.$v.data.pessoa_fisica.fone_celular.required && erros.push(MESSAGES.VALIDATION_REQUIRED)
      return erros
    },
    pessoaFisicaFoneProfissionalErros () {
      const erros = []
      if (!this.$v.data.pessoa_fisica.fone_profissional.$dirty) return erros
      !this.$v.data.pessoa_fisica.fone_profissional.required && erros.push(MESSAGES.VALIDATION_REQUIRED)
      return erros
    },
    pessoaFisicaFoneRecadoErros () {
      const erros = []
      if (!this.$v.data.pessoa_fisica.fone_recado.$dirty) return erros
      !this.$v.data.pessoa_fisica.fone_recado.required && erros.push(MESSAGES.VALIDATION_REQUIRED)
      return erros
    },
    pessoaFisicaRefEstadoCivilErros () {
      const erros = []
      if (!this.$v.data.pessoa_fisica.ref_estado_civil.$dirty) return erros
      !this.$v.data.pessoa_fisica.ref_estado_civil.required && erros.push(MESSAGES.VALIDATION_REQUIRED)
      return erros
    },
    pessoaFisicaRefRacaErros () {
      const erros = []
      if (!this.$v.data.pessoa_fisica.ref_raca.$dirty) return erros
      !this.$v.data.pessoa_fisica.ref_raca.required && erros.push(MESSAGES.VALIDATION_REQUIRED)
      return erros
    },
    pessoaFisicaRefNaturalidadeErros () {
      const erros = []
      if (!this.$v.data.pessoa_fisica.ref_naturalidade.$dirty) return erros
      !this.$v.data.pessoa_fisica.ref_naturalidade.required && erros.push(MESSAGES.VALIDATION_REQUIRED)
      return erros
    },
    pessoaFisicaRefNacionalidadeErros () {
      const erros = []
      if (!this.$v.data.pessoa_fisica.ref_nacionalidade.$dirty) return erros
      !this.$v.data.pessoa_fisica.ref_nacionalidade.required && erros.push(MESSAGES.VALIDATION_REQUIRED)
      return erros
    },
    pessoaFisicaNomeMaeErros () {
      const erros = []
      if (!this.$v.data.pessoa_fisica.nome_mae.$dirty) return erros
      !this.$v.data.pessoa_fisica.nome_mae.required && erros.push(MESSAGES.VALIDATION_REQUIRED)
      return erros
    },
    pessoaFisicaCpfErros () {
      const erros = []
      if (!this.$v.data.pessoa_fisica.cpf.$dirty) return erros
      !this.$v.data.pessoa_fisica.cpf.required && erros.push(MESSAGES.VALIDATION_REQUIRED)
      return erros
    },
    pessoaFisicaRgNumeroErros () {
      const erros = []
      if (!this.$v.data.pessoa_fisica.rg_numero.$dirty) return erros
      !this.$v.data.pessoa_fisica.rg_numero.required && erros.push(MESSAGES.VALIDATION_REQUIRED)
      return erros
    },
    pessoaFisicaSexoErros () {
      const erros = []
      if (!this.$v.data.pessoa_fisica.sexo.$dirty) return erros
      !this.$v.data.pessoa_fisica.sexo.required && erros.push(MESSAGES.VALIDATION_REQUIRED)
      return erros
    }
  },
  mounted () {
    this.data.pessoa = {...this.data.pessoa, ...this.dados.pessoa}
    this.data.pessoa_fisica = {...this.data.pessoa_fisica, ...this.dados.pessoa_fisica}
    if (this.data.pessoa.cidade) {
      this.dependencias.cidades.push(this.data.pessoa.cidade)
    }
    if (this.data.pessoa_fisica.naturalidade) {
      this.dependencias.cidades_naturalidade.push(this.data.pessoa_fisica.naturalidade)
    }
    this.buscarEstadosCivis()
    this.buscarRacas()
    this.buscarPaises()
  },
  watch: {
    buscarCidade: function (query) {
      if (!this.data.pessoa.ref_cidade) {
        this.buscarCidades(query, 'cidade')
      }
    },
    buscarNaturalidade: function (query) {
      if (!this.data.pessoa_fisica.ref_naturalidade) {
        this.buscarCidades(query, 'naturalidade')
      }
    }
  },
  methods: {
    ...mapActions(['setUser', 'showNotification']),
    buscarCidades (query, campo) {
      return new Promise((resolve, reject) => {
        if (query !== null && query !== '') {
          if (campo === 'cidade') {
            this.dependencias.cidades.splice(0)
          }
          if (campo === 'naturalidade') {
            this.dependencias.cidades_naturalidade.splice(0)
          }
          this.buscandoCidades = true
          let data = {nome: {ilike: '%' + query + '%'}}
          restfulService.search('cidade', null, data, null, ['estado'])
            .then((response) => {
              if (campo === 'cidade') {
                this.dependencias.cidades.splice(0)
                this.dependencias.cidades = [...this.dependencias.cidades, ...response.data]
              }
              if (campo === 'naturalidade') {
                this.dependencias.cidades_naturalidade.splice(0)
                this.dependencias.cidades_naturalidade = [...this.dependencias.cidades_naturalidade, ...response.data]
              }
              this.buscandoCidades = false
              resolve()
            })
            .catch(e => {
              console.log(e)
              this.buscandoCidades = false
              reject()
            })
        } else {
          resolve()
        }
      })
    },
    buscarEstadosCivis () {
      restfulService.get('basico', 'estados-civis')
        .then(response => {
          this.dependencias.estados_civis = [...this.dependencias.estados_civis, ...response]
        })
        .catch(e => {
          console.log(e)
        })
    },
    buscarRacas () {
      restfulService.get('basico', 'racas')
        .then(response => {
          this.dependencias.racas = [...this.dependencias.racas, ...response]
        })
        .catch(e => {
          console.log(e)
        })
    },
    buscarPaises () {
      restfulService.get('basico', 'paises')
        .then(response => {
          this.dependencias.paises = [...this.dependencias.paises, ...response]
        })
        .catch(e => {
          console.log(e)
        })
    },
    formatarDataNascimento () {
      this.$v.data.pessoa_fisica.dt_nascimento_formatada.$touch()
      this.data.pessoa_fisica.dt_nascimento = this.dateFormat(this.data.pessoa_fisica.dt_nascimento_formatada, 'en')
      bus.$emit('update-dt-nascimento', this.data.pessoa_fisica.dt_nascimento_formatada)
    },
    salvarDados () {
      this.botaoClicado = true
      bus.$emit('show-loader')
      let data = cloneDeep(this.data)
      delete data.necessidade
      delete data.pessoa.cidade
      delete data.pessoa.pessoa_fisica
      delete data.pessoa.usuario
      delete data.pessoa.necessidades_especiais
      delete data.pessoa_fisica.dt_nascimento_formatada
      delete data.pessoa_fisica.naturalidade
      delete data.pessoa.email_valido
      data.pessoa.cep = this.onlyNumbers(data.pessoa.cep)
      if (data.pessoa_fisica.fone_recado) {
        data.pessoa_fisica.fone_recado = this.onlyNumbers(data.pessoa_fisica.fone_recado)
      }
      if (data.pessoa_fisica.fone_profissional) {
        data.pessoa_fisica.fone_profissional = this.onlyNumbers(data.pessoa_fisica.fone_profissional)
      }
      if (data.pessoa_fisica.fone_celular) {
        data.pessoa_fisica.fone_celular = this.onlyNumbers(data.pessoa_fisica.fone_celular)
      }
      if (data.pessoa_fisica.fone_residencial) {
        data.pessoa_fisica.fone_residencial = this.onlyNumbers(data.pessoa_fisica.fone_residencial)
      }
      delete data.endereco_cobranca
      delete data.pessoa_fisica.formacao_academica
      delete data.pessoa_fisica.experiencias_profissionais
      restfulService.post('pessoa', null, null, data)
        .then(() => {
          this.showNotification({
            message: 'Seus dados pessoais foram salvos'
          })
          this.$v.data.pessoa.$reset()
          this.$v.data.pessoa_fisica.$reset()
          let usuario = this.currentUser
          usuario.pessoa.nome = data.pessoa.nome
          this.setUser(usuario)
          this.botaoClicado = false
          bus.$emit('hide-loader')
        })
        .catch(e => {
          this.botaoClicado = false
          bus.$emit('hide-loader')
          console.log(e)
        })
    }
  }
}
</script>

<template>
  <v-form>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex sm6 xs12>
          <v-text-field v-model="data.pessoa.nome"
                        label="Nome"
                        :error-messages="pessoaNomeErros"
                        @input="$v.data.pessoa.nome.$touch()"
                        @blur="$v.data.pessoa.nome.$touch()"
                        required/>
        </v-flex>
        <v-flex md3 sm6 xs12>
          <v-select :items="dependencias.tipos_sexo"
                    :error-messages="pessoaFisicaSexoErros"
                    @input="$v.data.pessoa_fisica.sexo.$touch()"
                    @blur="$v.data.pessoa_fisica.sexo.$touch()"
                    v-model="data.pessoa_fisica.sexo"
                    label="Sexo"
                    clearable/>
        </v-flex>
        <v-flex md3 sm6 xs12>
          <v-menu ref="datepickerDtNascimento"
                  :close-on-content-click="false"
                  v-model="mostrarDatepickerDtNascimento"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  max-width="290px"
                  min-width="290px">
            <v-text-field slot="activator"
                          v-model="data.pessoa_fisica.dt_nascimento_formatada"
                          @blur="formatarDataNascimento"
                          v-mask="'##/##/####'"
                          label="Data de Nascimento"
                          prepend-icon="event"/>
            <v-date-picker v-model="data.pessoa_fisica.dt_nascimento"
                           @input="formatarDataNascimento"
                           @blur="formatarDataNascimento"
                           :error-messages="pessoaFisicaDtNascimentoErros"
                           locale="pt-br"/>
          </v-menu>
        </v-flex>
        <v-flex sm6 xs12>
          <v-text-field v-model="data.pessoa_fisica.cpf"
                        label="CPF"
                        :error-messages="pessoaFisicaCpfErros"
                        @input="$v.data.pessoa_fisica.cpf.$touch()"
                        @blur="$v.data.pessoa_fisica.cpf.$touch()"
                        mask="###.###.###-##"
                        required/>
        </v-flex>
        <v-flex sm6 xs12>
          <v-text-field v-model="data.pessoa_fisica.rg_numero"
                        label="RG"
                        :error-messages="pessoaFisicaRgNumeroErros"
                        @input="$v.data.pessoa_fisica.rg_numero.$touch()"
                        @blur="$v.data.pessoa_fisica.rg_numero.$touch()"
                        required/>
        </v-flex>
        <v-flex sm6 xs12>
          <v-text-field v-model="data.pessoa_fisica.nome_mae"
                        label="Nome da Mãe"
                        :error-messages="pessoaFisicaNomeMaeErros"
                        @input="$v.data.pessoa_fisica.nome_mae.$touch()"
                        @blur="$v.data.pessoa_fisica.nome_mae.$touch()"
                        required/>
        </v-flex>
        <v-flex md3 sm6 xs12>
          <v-select :items="dependencias.estados_civis"
                    item-value="id"
                    item-text="descricao"
                    :error-messages="pessoaFisicaRefEstadoCivilErros"
                    @input="$v.data.pessoa_fisica.ref_estado_civil.$touch()"
                    @blur="$v.data.pessoa_fisica.ref_estado_civil.$touch()"
                    v-model="data.pessoa_fisica.ref_estado_civil"
                    label="Estado civil"
                    clearable/>
        </v-flex>
        <v-flex md3 sm6 xs12>
          <v-select :items="dependencias.racas"
                    item-value="id"
                    item-text="descricao"
                    :error-messages="pessoaFisicaRefRacaErros"
                    @input="$v.data.pessoa_fisica.ref_raca.$touch()"
                    @blur="$v.data.pessoa_fisica.ref_raca.$touch()"
                    v-model="data.pessoa_fisica.ref_raca"
                    label="Etnia"
                    clearable/>
        </v-flex>
        <v-flex md4 sm6 xs12>
          <v-autocomplete v-model="data.pessoa_fisica.ref_naturalidade"
                          :error-messages="pessoaFisicaRefNaturalidadeErros"
                          @input="$v.data.pessoa_fisica.ref_naturalidade.$touch()"
                          @blur="$v.data.pessoa_fisica.ref_naturalidade.$touch()"
                          :items="dependencias.cidades_naturalidade"
                          :loading="buscandoCidades"
                          :search-input.sync="buscarNaturalidade"
                          item-text="nome"
                          item-value="id"
                          label="Naturalidade"
                          placeholder="Digite o nome da cidade"
                          no-data-text="Nenhum registro encontrado"
                          hide-no-data
                          hide-selected
                          clearable/>
        </v-flex>
        <v-flex md4 sm6 xs12>
          <v-select :items="dependencias.paises"
                    :error-messages="pessoaFisicaRefNacionalidadeErros"
                    @input="$v.data.pessoa_fisica.ref_nacionalidade.$touch()"
                    @blur="$v.data.pessoa_fisica.ref_nacionalidade.$touch()"
                    item-value="id"
                    item-text="nome"
                    v-model="data.pessoa_fisica.ref_nacionalidade"
                    label="Nacionalidade"
                    clearable/>
        </v-flex>
        <v-flex md4 sm6 xs12>
          <v-select :items="dependencias.tipos_sanguineos"
                    v-model="data.pessoa_fisica.tipo_sanguineo"
                    label="Tipo Sanguíneo"
                    clearable/>
        </v-flex>
        <v-flex sm3 xs12>
          <v-text-field v-model="data.pessoa.cep"
                        :error-messages="pessoaCepErros"
                        @input="$v.data.pessoa.cep.$touch()"
                        @blur="$v.data.pessoa.cep.$touch()"
                        mask="#####-###"
                        label="CEP"
                        required/>
        </v-flex>
        <v-flex sm6 xs12>
          <v-text-field v-model="data.pessoa.rua"
                        :error-messages="pessoaRuaErros"
                        @input="$v.data.pessoa.rua.$touch()"
                        @blur="$v.data.pessoa.rua.$touch()"
                        label="Rua"
                        required/>
        </v-flex>
        <v-flex sm3 xs12>
          <v-text-field v-model="data.pessoa.numero"
                        :error-messages="pessoaNumeroErros"
                        @input="$v.data.pessoa.numero.$touch()"
                        @blur="$v.data.pessoa.numero.$touch()"
                        label="Número"
                        required/>
        </v-flex>
        <v-flex sm4 xs12>
          <v-text-field v-model="data.pessoa.complemento"
                        label="Complemento"/>
        </v-flex>
        <v-flex sm4 xs12>
          <v-text-field v-model="data.pessoa.bairro"
                        :error-messages="pessoaBairroErros"
                        @input="$v.data.pessoa.bairro.$touch()"
                        @blur="$v.data.pessoa.bairro.$touch()"
                        label="Bairro"
                        required/>
        </v-flex>
        <v-flex sm4 xs12>
          <v-autocomplete v-model="data.pessoa.ref_cidade"
                          :error-messages="pessoaRefCidadeErros"
                          @input="$v.data.pessoa.ref_cidade.$touch()"
                          @blur="$v.data.pessoa.ref_cidade.$touch()"
                          :items="dependencias.cidades"
                          :loading="buscandoCidades"
                          :search-input.sync="buscarCidade"
                          item-text="nome"
                          item-value="id"
                          label="Cidade"
                          placeholder="Digite o nome da cidade"
                          no-data-text="Nenhum registro encontrado"
                          hide-no-data
                          hide-selected
                          clearable/>
        </v-flex>
        <v-flex md3 sm6 xs12>
          <v-text-field v-model="data.pessoa_fisica.fone_residencial"
                        :error-messages="pessoaFisicaFoneResidencialErros"
                        @input="$v.data.pessoa_fisica.fone_residencial.$touch()"
                        @blur="$v.data.pessoa_fisica.fone_residencial.$touch()"
                        mask="(##) ####-####"
                        label="Telefone Residencial"/>
        </v-flex>
        <v-flex md3 sm6 xs12>
          <v-text-field v-model="data.pessoa_fisica.fone_celular"
                        :error-messages="pessoaFisicaFoneCelularErros"
                        @input="$v.data.pessoa_fisica.fone_celular.$touch()"
                        @blur="$v.data.pessoa_fisica.fone_celular.$touch()"
                        mask="(##) #####-####"
                        label="Telefone Celular"/>
        </v-flex>
        <v-flex md3 sm6 xs12>
          <v-text-field v-model="data.pessoa_fisica.fone_profissional"
                        :error-messages="pessoaFisicaFoneProfissionalErros"
                        @input="$v.data.pessoa_fisica.fone_profissional.$touch()"
                        @blur="$v.data.pessoa_fisica.fone_profissional.$touch()"
                        mask="(##) ####-####"
                        label="Telefone Profissional"/>
        </v-flex>
        <v-flex md3 sm6 xs12>
          <v-text-field v-model="data.pessoa_fisica.fone_recado"
                        :error-messages="pessoaFisicaFoneRecadoErros"
                        @input="$v.data.pessoa_fisica.fone_recado.$touch()"
                        @blur="$v.data.pessoa_fisica.fone_recado.$touch()"
                        label="Telefone de Recado"/>
        </v-flex>
        <v-flex sm6 xs12>
          <v-text-field v-model="data.pessoa.email"
                        label="E-mail Principal"
                        :error-messages="pessoaEmailErros"
                        @input="$v.data.pessoa.email.$touch()"
                        @blur="$v.data.pessoa.email.$touch()"
                        required/>
        </v-flex>
        <v-flex sm6 xs12>
          <v-text-field v-model="data.pessoa.email_alternativo"
                        :error-messages="pessoaEmailAlternativoErros"
                        @input="$v.data.pessoa.email_alternativo.$touch()"
                        @blur="$v.data.pessoa.email_alternativo.$touch()"
                        label="E-mail Alternativo"/>
        </v-flex>
      </v-layout>
      <v-btn color="success"
             @click="salvarDados()"
             :disabled="botaoClicado || $v.data.pessoa.$invalid || $v.data.pessoa_fisica.$invalid">
        <i class="fas fa-check"></i>
        <span class="pl-2">Salvar Dados</span>
      </v-btn>
    </v-container>
  </v-form>
</template>



// WEBPACK FOOTER //
// DadosCadastrais.vue?a508810e